import React from "react";
import { Text } from "~/Text/index.js";

const NoData = () => (
    <div className={"text-center p-24"}>
        <Text>{"No records found."}</Text>
    </div>
);

export { NoData };
